import SettingsPageHead from './settings-page-head.vue'
import HeadOfSettingsSection from './head-of-settings-section'
import GmhProfileEdit from './gmh-profile-edit'
import GmhAccountEdit from './gmh-account-edit'
import SettingsBecomeCreator from './settings-become-creator'
import SettingsEarningDashboard from './settings-earning-dashboard'
import SettingsPurchased from './settings-purchased'

export default {
    SettingsPageHead,
    HeadOfSettingsSection,
    GmhProfileEdit,
    GmhAccountEdit,
    SettingsBecomeCreator,
    SettingsEarningDashboard,
    SettingsPurchased,
}
